import { useEffect, useState } from "react";
import { fetchPayloads, fetchPayloadByOperation, type PayloadMeta } from "../api";

type DetailState =
  | { kind: "closed" }
  | { kind: "loading"; opId: string }
  | { kind: "loaded"; opId: string; body: unknown }
  | { kind: "error"; opId: string; message: string };

export function Payloads() {
  const [items, setItems] = useState<PayloadMeta[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [detail, setDetail] = useState<DetailState>({ kind: "closed" });

  const refresh = () => {
    setError(null);
    fetchPayloads(100)
      .then((r) => setItems(r.items))
      .catch((e: unknown) => setError(e instanceof Error ? e.message : String(e)));
  };

  useEffect(refresh, []);

  const openDetail = async (opId: string) => {
    setDetail({ kind: "loading", opId });
    try {
      const found = await fetchPayloadByOperation(opId);
      if (!found) {
        setDetail({ kind: "error", opId, message: "no encontrado" });
        return;
      }
      setDetail({ kind: "loaded", opId, body: found.body });
    } catch (e: unknown) {
      setDetail({
        kind: "error",
        opId,
        message: e instanceof Error ? e.message : String(e),
      });
    }
  };

  return (
    <section className="card">
      <div className="card-head">
        <h2>Payloads recibidos</h2>
        <button type="button" onClick={refresh}>↻ Refrescar</button>
      </div>

      {error && <p className="error">Error: {error}</p>}
      {!error && items === null && <p>Cargando…</p>}
      {items !== null && items.length === 0 && (
        <p className="meta">No hay payloads recibidos todavía.</p>
      )}

      {items !== null && items.length > 0 && (
        <table className="data">
          <thead>
            <tr>
              <th>Recibido</th>
              <th>operation_id</th>
              <th>OK</th>
              <th>Code</th>
              <th>Tamaño</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {items.map((it) => (
              <tr key={it.filename}>
                <td>{new Date(it.receivedAt).toLocaleString()}</td>
                <td>
                  <code>{it.operationId}</code>
                  <OperationIdOrigin operationId={it.operationId} />
                </td>
                <td>{it.success ? "✅" : "❌"}</td>
                <td>{it.errorCode || ""}</td>
                <td>{(it.sizeBytes / 1024).toFixed(1)} KB</td>
                <td>
                  <button type="button" onClick={() => openDetail(it.operationId)}>
                    Ver JSON
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {detail.kind !== "closed" && (
        <div className="detail">
          <div className="card-head">
            <h3>operation_id <code>{detail.opId}</code></h3>
            <button type="button" onClick={() => setDetail({ kind: "closed" })}>
              ✕ Cerrar
            </button>
          </div>
          {detail.kind === "loading" && <p>Cargando…</p>}
          {detail.kind === "error" && <p className="error">{detail.message}</p>}
          {detail.kind === "loaded" && (
            <pre>{JSON.stringify(detail.body, null, 2)}</pre>
          )}
        </div>
      )}
    </section>
  );
}

function OperationIdOrigin({ operationId }: { operationId: string }) {
  let text: string | null = null;
  let title = "";
  if (operationId === "no-op-id") {
    text = "legacy";
    title = "Payload guardado antes de que el backend generase ids sinteticos. Sin id real de Wealth Reader.";
  } else if (operationId.startsWith("wh-")) {
    text = "webhook";
    title = "Wealth Reader no envio operation_id; el webhook asigno uno sintetico.";
  } else if (operationId.startsWith("refresh-")) {
    text = "refresh manual";
    title = "Refresco desde /credenciales sin operation_id devuelto por WR.";
  }
  if (!text) return null;
  return (
    <span className="meta" style={{ marginLeft: "0.4rem", fontSize: "0.8em" }} title={title}>
      · {text}
    </span>
  );
}
